// boot/utils.js
export const isNovoCadastro = (uuid) => !(uuid && uuid !== "null");

export const mergeIfEmpty = (prev, patch) => {
    const out = { ...prev };
    let changed = false;

    Object.keys(patch || {}).forEach((k) => {
        const prevVal = prev?.[k];
        const nextVal = patch[k];

        const empty =
            prevVal === undefined || prevVal === null || prevVal === "" || (Array.isArray(prevVal) && prevVal.length === 0);

        if (empty && nextVal !== undefined) {
            out[k] = nextVal;
            changed = true;
        }
    });

    return changed ? out : prev;
};

export const mergeAlways = (prev, patch) => {
    const out = { ...prev };
    let changed = false;

    Object.keys(patch || {}).forEach((k) => {
        if (patch[k] !== undefined && patch[k] !== prev?.[k]) {
            out[k] = patch[k];
            changed = true;
        }
    });

    return changed ? out : prev;
};
